import React from 'react';
import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import { HomeJumbotronSection } from '../Components/HomeJumbotronSection';
import { HowItWorksSection } from '../LoopAppSection/sections/HowItWorksSection';
import { EarnToSpend } from './sections/EarnToSpend';
import { PrivacySection } from './sections/PrivacySection';
import { CTA } from 'Pages/LoopForBusiness/CTA';
import { useLoopLandingPageLocalization } from 'Utils/localizationHooks';
import { MetaData } from 'Components/MetaData/Metadata';
import { IImageSlider } from 'Types/Interface/ILandingPage';
import { useLocale } from 'context/LocalizationContext';
import StorageService from 'Utils/storageService';
import Scan from 'Assets/Images/Scan.png';
import EarnPoints from 'Assets/Images/EarnPoints.png';
import AnswerSurvey from 'Assets/Images/AnswerSurvey.png';
import MobileAnswerSurvery from 'Assets/Images/MobileAnswerSurvery.png';
import MobileEarnPoints from 'Assets/Images/MobileEarnPoints.png';
import MobileScan from 'Assets/Images/MobileScan.png';

export const HomePage = () => {
	const {localization: loopLandingPageLocalization} = useLoopLandingPageLocalization();
	const { country, locale } = useLocale();
	
	
	const getCanonicalUrl = () => {
		if (typeof window !== 'undefined') {
			return `${window.location.origin}${window.location.pathname}`;
		}
		
		const countryCode = country?.url || StorageService.getCountryUrlOrDefault();
		const localeCode = locale || StorageService.getLanguageOrDefault();
		return `https://www.feedtheloop.com/${countryCode}/${localeCode}/`;
	};

	const getOgImage = () => {
		if (typeof window !== 'undefined') {
			return `${window.location.origin}/icon-512x512.png`;
		}
		return 'https://www.feedtheloop.com/icon-512x512.png';
	};

	const Carousels: IImageSlider[] = [
		{
			id: 0,
			label: loopLandingPageLocalization?.firstStepTitle,
			src: Scan,
			mobileSrc:MobileScan,
			text: loopLandingPageLocalization?.firstStepDescription
		},
		{
			id: 1,
			label: loopLandingPageLocalization?.secondStepTitle ,
			src: AnswerSurvey,
			mobileSrc: MobileAnswerSurvery,
			text: loopLandingPageLocalization?.secondStepDescription
		},
		{
			id: 2,
			label: loopLandingPageLocalization?.thirdStepTitle,
			src: EarnPoints,
			mobileSrc:MobileEarnPoints,
			text: loopLandingPageLocalization?.thirdStepDescription
		}
	];
	return (
		<>
			<MetaData 
				title='Loop: Join the Conversation with Your Favorite Brands'
				description='Share your thoughts, earn cash rewards, and help shape the products you love—all with full control of your privacy.'
				keywords='earn money, brand rewards, cash back, products, consumer surveys, brand engagement, instant rewards'
				canonicalUrl={getCanonicalUrl()}
				ogImage={getOgImage()}
				ogUrl={getCanonicalUrl()}
				twitterSite='Loop'
				lang={locale || 'en'}
				structuredData={{
					'@context': 'https://schema.org',
					'@type': 'WebApplication',
					'name': 'Loop',
					'description': 'Share your thoughts, earn cash rewards, and help shape the products you love—all with full control of your privacy.',
					'url': getCanonicalUrl(),
					'applicationCategory': 'BusinessApplication',
					'operatingSystem': 'Web',
					'offers': {
						'@type': 'Offer',
						'category': 'Rewards Program',
						'description': 'Earn cash rewards by engaging with your favorite brands'
					}
				}}
			/>
			<LandingPageLayout
				JumbotronSection={<HomeJumbotronSection loopLandingPageLocalization={loopLandingPageLocalization} />}
			>
				<HowItWorksSection isLoopBusiness={false} mainHeading={loopLandingPageLocalization?.mainHeading} secondaryHeading={loopLandingPageLocalization?.secondaryHeading} loopLandingPageLocalization={loopLandingPageLocalization} SliderContent={Carousels} />
				<EarnToSpend loopLandingPageLocalization={loopLandingPageLocalization} />
				<PrivacySection loopLandingPageLocalization={loopLandingPageLocalization} />
				<CTA isCTA isBusiness={false} ctaSubText={loopLandingPageLocalization?.ctaSubtext} ctaText={loopLandingPageLocalization?.ctaText} shouldIgnoreParentPadding />
			</LandingPageLayout>
		</>
	);
};